import { SxProps } from '@mui/material';
import { grey } from 'app/components/ThemeProvider/colors';

export const paperProps: SxProps = {
  borderRadius: '8px',
  width: '517px',
  maxHeight: 'none',
};

export const dialogTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: '28px',
  padding: '40px 40px',
  paddingBottom: '0px',
};

export const closeBtn: SxProps = {
  position: 'absolute',
  top: '32px',
  right: '32px',
  padding: '10px',
  minWidth: '36px',
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  alignItems: 'centre',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};
export const dialogContent: SxProps = {
  display: 'flex',
  padding: '42px',
  flexDirection: 'column',
  gap: '20px',
  overflow: 'auto',
};

export const dialogContentBoxes: SxProps = { display: 'flex', flexDirection: 'column', gap: '8px', pr: '35px' };

export const inputOutlined: SxProps = {
  fontSize: '16px',
  fontWeight: 400,
  height: '48px',
  paddingLeft: '16px',
  borderWidth: '1px',
  borderRadius: '8px',
  '& .MuiInputBase-input::placeholder': {
    fontSize: '16px',
    fontWeight: '400px',
    color: 'rgba(20, 25, 31, 0.4)',
  },

  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: grey,
    borderWidth: '0.5px',
  },
};

export const btnsBox: SxProps = {
  display: 'flex',
  gap: '12px',
  marginTop: '7px',
  padding: 0,
  flexDirection: 'row',
};
